import { render, staticRenderFns } from "./APIReg.vue?vue&type=template&id=19bc35e1&scoped=true"
import script from "./APIReg.vue?vue&type=script&lang=js"
export * from "./APIReg.vue?vue&type=script&lang=js"
import style0 from "./APIReg.vue?vue&type=style&index=0&id=19bc35e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bc35e1",
  null
  
)

export default component.exports